<template>
    <!-- Pass data to 'MapComponent Create Component' -->
    <!-- Check for authenticated users -->
    <map-create-component
            :offers-data="offersData"
            :auth-check="authCheck"
    />
</template>

<script>
  import MapCreateComponent from '../MapCreate/MapCreate';
  import {bus} from '../filter-parent';

  export default {
    name: "map-component",
    props: {
      formData: '',
      offersData: '',

      //*** Auth Guard ***
      authCheck: ''

    },
    data: function () {
      return {
        offers: this.offersData,
      }
    },
    methods: {},
    components: {
      MapCreateComponent
    },
    computed: {},
    mounted() {
      //bus.$emit('componentLoaded', true);
    },
    created() {
      let formState = this.formData;
      //**** Event Bus ****//
      bus.$on('searchResults', data => {
        formState = JSON.stringify(data);
        //console.log(JSON.stringify(formState));
      });
    },

  }
</script>